<div mat-dialog-title class="dialog-info" closeOnEscape>
    <label class="dialogTitle">
        {{'SEARCH_OPPORTUNITY' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<mat-dialog-content class="contentPadding" [formGroup]="searchOpportunityForm">
    <!-- First Row -->
    <div class="searchInputRow">
        <div class="inputContainer">
            <label class="inputLabel">{{'ID' | translate}}:</label>
            <mat-form-field appearance="outline" class="inputFormField">
                <input matInput formControlName="id">
            </mat-form-field>
        </div>
        <div class="inputContainer">
            <label class="inputLabel">{{'SAP_JOB_NUMBER' | translate}}:</label>
            <mat-form-field appearance="outline" class="inputFormField">
                <input matInput formControlName="sapJobNumber">
            </mat-form-field>
        </div>
    </div>

    <!-- Second Row -->
    <div class="searchInputRow">
        <div class="inputContainer">
            <label class="inputLabel">{{'NAME' | translate}}:</label>
            <mat-form-field appearance="outline" class="inputFormField">
                <input matInput formControlName="name">
            </mat-form-field>
        </div>
        <div class="inputContainer"></div>
    </div>

    <!-- Search Button -->
    <div style="margin-top: 10px;">
        <button mat-raised-button color="primary" (click)="searchOpportunity()">{{'SEARCH' | translate}}</button>
    </div>

    <!-- Results Area -->
    <div style="margin-top: 10px; height: 200px; overflow: auto;">
        <table mat-table [dataSource]="dataSource" matSort
            class="full-width table table-bordered mat-elevation-z8">
            
                <ng-container matColumnDef="opportunityId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'OPPORTUNITY_ID' | translate }} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.opportunityId}} </td>
            </ng-container>
            
                <ng-container matColumnDef="opportunityName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'OPPORTUNITY_NAME' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.opportunityName}} </td>
            </ng-container>
            
                <ng-container matColumnDef="opportunityDescription">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'DESCRIPTION' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.opportunityDescription}} </td>
            </ng-container>
            
            <ng-container matColumnDef="sapJobNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'SAP_JOB_NUMBER' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.sapJobNumber}} </td>
            </ng-container>
            
                <ng-container matColumnDef="soldToSAPNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'SOLD_TO' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.soldToSAPNumber}} </td>
            </ng-container>
            
            <ng-container matColumnDef="buyAmerican">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'BUY_AMERICAN' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.buyAmerican}} </td>
            </ng-container>
            
            <ng-container matColumnDef="restrictedType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'RESTRICTED_TYPE' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.restrictedType}} </td>
            </ng-container>
    
            <!-- Header row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="row-height row-header" ></tr>
            <!-- Data rows -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row-height"
                [class.selected]="selectedRow === row" (click)="onRowClick(row)" (dblclick)="onDblClick(row)">
            </tr>
    
            <!-- Row shown when there is no matching data -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data text-center" [attr.colspan]="displayedColumns.length">{{
                    'COMMON_LABELS.NO_DATA_FOUND' | translate }}</td>
            </tr>
        </table>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="actionsPadding">
    <button class="openCloseBtn" mat-raised-button color="primary" >{{ 'HELP' | translate }}</button>
    <button class="openCloseBtn" mat-raised-button color="primary" (click)="resetForm()">{{ 'RESET' | translate }}</button>
    <button class="openCloseBtn" mat-raised-button color="primary" [disabled]="!selectedRow" (click)="opportunityRowSelected()">{{ 'SELECT' | translate }}</button>
    <button class="openCloseBtn" mat-raised-button color="warn" mat-dialog-close>{{'CANCEL' | translate}}</button>
</mat-dialog-actions>